jQuery(function ($) {
	$(document).ready(function () {
		// ScrollTrigger.create({
		// 	trigger: "#intro",
		// 	start: "top 30%",
		// 	// end: "top 30%",
		// 	onEnter: () => $("#contact").addClass("animated"),
		// 	onLeaveBack: () => $("#contact").removeClass("animated"),
		// });

		$(".awards").slick({
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 900,
			autoplay: true,
			autoplaySpeed: 4000,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 1200,
					settings: "unslick",
				},
			],
		});

		$("#procedures .p__container").hover(
			function () {
				$(this).addClass("hover");
			},
			function () {
				$(this).removeClass("hover");
			}
		);
	});

	$(window).on("resize", function () {
		if (!$(".awards.slick-initialized").length) {
			$(".awards").slick("reinit");
		}
	});
});
